import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import EndPoints from "src/Constants/EndPoints";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useTranslation } from "react-i18next";

function FeedOptions({
  id,
  groupId,
  subId,
  refetch,
  is_bookmark,
  data,
  setPostData,
  setModalVisibility,
  setReportData,
  setShowReportModal,
}: any) {
  const { user } = AppStateHandler.getState();
  const { path } = useRouteMatch();
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [bookmarkPost, { status: bookmarkStatus }] = useApiMutation({
    onSettled: () => refetch(),
  });

  const [deletePost, { status: deleteStatus }] = useApiMutation({
    onSettled: () => {
      refetch();
      history.goBack();
    },
  });

  const [hidePost, { status: hideStatus }] = useApiMutation({
    onSettled: () => refetch(),
  });

  const bookmarkFn = (e: any) => {
    e.preventDefault();
    if (bookmarkStatus === "loading") {
      return;
    }
    bookmarkPost({
      url: EndPoints.bookmarkPost,
      data: {
        subId: user?.username,
        postId: id,
        groupId: groupId,
      },
    });
  };

  const hideFn = (e: any) => {
    e.preventDefault();
    if (hideStatus === "loading") {
      return;
    }
    hidePost({
      url: EndPoints.hidePost,
      data: {
        subId: user?.username,
        postId: id,
        groupId: groupId,
      },
    });
  };

  const setEditDataFn = (e: any) => {
    e.preventDefault();
    setPostData(data);
    setModalVisibility(true);
  };

  const deleteFn = (e: any) => {
    e.preventDefault();
    if (deleteStatus === "loading") {
      return;
    }
    const response = window.confirm("Are you sure ?");
    if (response === true) {
      deletePost({
        url: EndPoints.deletePost,
        data: {
          subId: user?.username,
          postId: id,
          groupId: groupId,
        },
      });
    }
  };

  const handleReportPost = (e: any) => {
    e.preventDefault();
    const type = path.includes('/groups/:id') ? "group" : "post"
    const report = {
      data: { postId: data.id },
      type: type,
      endPoint: EndPoints.reportPost
    }
    setReportData(report);
    setShowReportModal(true);
  }
  return (
    <div className={`slider_down_arrow position-relative ${i18n.dir() === 'rtl'?'pr':'pl'}-4`}>
      <i className="fa fa-angle-down fz26 py-2" aria-hidden="true"></i>
      <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL':'user_actions_posLTR'}`}>
        <ul className={`list-unstyled  ${i18n.dir()==='rtl'?'text-right Almaraibold':'text-left poppinsbold'} mb-0 `}>
          <VisibilityToggle visible={user.username === subId}>
            <li>
              <a
                className="py-4 d-flex align-items-center"
                href="/"
                onClick={deleteFn}
              >
                <VisibilityToggle visible={deleteStatus === "loading"}>
                  <span className="spinner-border spinner-border-sm"></span>
                  &nbsp;
                </VisibilityToggle>
                {t("Delete")}
              </a>
            </li>
          </VisibilityToggle>
          <VisibilityToggle visible={user.username !== subId}>
            <li>
              <a
                className="py-4 d-flex align-items-center"
                href="/"
                onClick={hideFn}
              >
                <VisibilityToggle visible={hideStatus === "loading"}>
                  <span className="spinner-border spinner-border-sm"></span>
                  &nbsp;
                </VisibilityToggle>
                {path.includes("hidden-posts") ? t("Unhide") : t("Hide")}
              </a>
            </li>
          </VisibilityToggle>
          <VisibilityToggle visible={user.username === subId}>
            <li>
              <a
                className="py-4 d-flex align-items-center"
                href="/"
                onClick={setEditDataFn}
              >
                {t("Edit")}
              </a>
            </li>
          </VisibilityToggle>
          <VisibilityToggle visible={user.username !== subId}>
            <li>
              <a className="py-4 d-flex align-items-center" href="/" onClick={handleReportPost}>
                {t("Report")}
              </a>
            </li>
          </VisibilityToggle>
          <VisibilityToggle visible={user.username !== subId}>
            <li>
              <a
                className="py-4 d-flex align-items-center"
                href="/"
                onClick={bookmarkFn}
              >
                <VisibilityToggle visible={bookmarkStatus === "loading"}>
                  <span className="spinner-border spinner-border-sm"></span>
                  &nbsp; &nbsp;
                </VisibilityToggle>
                {is_bookmark ? t("Remove Bookmark") : t("Add Bookmark")}
              </a>
            </li>
          </VisibilityToggle>
        </ul>
      </div>
    </div>
  );
}

export default FeedOptions;
